import globalTranslations from "../translations";

const getMessageFromErrorCode = (code) => {
  return globalTranslations[code] || globalTranslations[403];
};

export default getMessageFromErrorCode;
